import { Version } from '@repo/toolkit/types'
import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  ArrivalAndDeparture,
  ArrivalAndDepartureFilters,
  ArrivalAndDepartureSort
} from '../../lib/types/models/arrival-and-departure/arrival-and-departure'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getArrivalAndDepartures(
  query: PaginationRequest<
    ArrivalAndDepartureFilters,
    string,
    Version,
    ArrivalAndDepartureSort
  > = {}
) {
  if (!query.sort) query.sort = { fromTo: 'asc' }
  return restApiClient
    .url(encodeNestedObject(API.arrivalAndDeparture.getAll.url, query))
    .get<PaginationResponse<ArrivalAndDeparture>>()
}
